module.exports = __webpack_public_path__ + "media/images/newsletter/setouchi/area-7-23a79a8bf7b7344f8a0532c9da08b4cb.jpg";